var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"w-full flex flex-col"},[_c('company-styles'),_vm._v(" "),_c('router-view',{staticClass:"view",attrs:{"keep-alive":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }